export enum BookedFormState {
  New = 0,
  Booked = 10,
  Draft = 20,
  Completed = 30,
  JournalizationPending = 40,
  Journalized = 50,
  Cancelled = 60
}
